import React from 'react';
import { useSelector } from 'react-redux';
import { getUserName } from '@redux/selectors/UserSelector';

import Button from 'react-bootstrap/Button';
import spinIcon from '@images/logos/vendor/spin_logo.gif';
import GAEventTracking from '@components/tracking/GAEventTracking';

const SpinWidget = () => {
  const gaEventTracker = GAEventTracking('User');
  const username = useSelector(getUserName);

  return (
    <div className="panel-content text-center rounded" style={{ backgroundColor: '#fff', minHeight: '231px' }}>
      <img alt="spin-icon" src={spinIcon} className="img-fluid mb-2" style={{ height: '60px' }} />
      <p className="mb-4" style={{ color: 'var(--darkBackground-4)' }}>Land titles data products, registered survey plans, township images, survey control markers, soil capability information and other land information.</p>
      <Button
        onClick={() => {
          window.open('https://alta.registries.gov.ab.ca/spinii/logon.aspx', '_blank');
          gaEventTracker('Opened Spin', `${username}`);
        }}
        variant="primary"
        className="pos-right"
      >
        <i className="far fa-external-link mr-2" />
        Spin2
      </Button>
    </div>
  );
};

export default SpinWidget;
